import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import DataTable from 'react-data-table-component';
import ReactFileReader from 'react-file-reader';
import Tooltip from 'react-simple-tooltip';
import Toggle from 'react-toggle';

import axios from 'axios';
import { ethers } from 'ethers';
import Papa from 'papaparse';

import { useGlobalContext } from '../../AppContext';
import { ProfileWalletsTableDataProps } from '../../constants/interfaces';
import { networks } from '../../utils/constants';
import { BigMenu } from '../../components/BigMenu';
import { Button } from '../../components/Button';
import { ConfirmAlert } from '../../components/ConfirmAlert';

import './Profile.scss';

export const Profile = () => {
  const { config, isMobile } = useGlobalContext();

  // use state
  const [showTable, setShowTable] = useState<JSX.Element>(<></>);
  const [tableData, setTableData] = useState<ProfileWalletsTableDataProps[]>([]);
  const [rawData, setRawData] = useState<any>(false);
  const [loading, setLoading] = useState<any>(true);
  const [currentImportLine, setCurrentImportLine] = useState<number>(0);

  const [walletRenderList, setWalletRenderList] = useState<any>();
  const [showCSVLoadingScreen, setShowCSVLoadingScreen] = useState<any>(false);
  const [importedWallets, setImportedWallets] = useState<string[]>([]);

  const [CSVResult, setCSVResult] = useState<any>({});

  const [redirect, setRedirect] = useState<boolean>(false);

  const [newAddress, setNewAddress] = useState<string>('');
  const [newName, setNewName] = useState<string>('');
  const [newNetwork, setNewNetwork] = useState<string[]>([]);
  const [validNewWallet, setValidNewWallet] = useState<boolean>(false);

  const [updateId, setUpdateId] = useState<string>('');
  const [updateAddress, setUpdateAddress] = useState<string>('');
  const [updateName, setUpdateName] = useState<string>('');
  const [updateNetwork, setUpdateNetwork] = useState<string[]>([]);

  const [showAddNewWallet, setShowAddNewWallet] = useState<boolean>(false);
  const [showAddNewWalletError, setShowAddNewWalletError] = useState<string>('');

  const [showUpdateWallet, setShowUpdateWallet] = useState<boolean>(false);
  const [showUpdateWalletError, setShowUpdateWalletError] = useState<string>('');
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('dark') ? 'light' : 'dark';
      setTheme(newTheme);
    };

    handleThemeChange();

    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);
  // const variables
  const walletsColumns = [
    {
      name: 'Name',
      selector: (row: ProfileWalletsTableDataProps) => row.name,
      sortable: false,
      cell: (row: ProfileWalletsTableDataProps) => {
        return (
          <>
            <Toggle
              icons={{ checked: <>Hide</>, unchecked: <>Unhide</> }}
              className="toggle-class"
              defaultChecked={!row.hidden}
              onChange={() => hideWallet(row.id, !!row.hidden)}
            />
            {row.name}
          </>
        );
      },
    },
    {
      name: 'Address',
      selector: (row: ProfileWalletsTableDataProps) =>
        `${row.address!.substr(0, 14)}...${row.address!.substr(-14, 14)}`,
      sortable: false,
    },
    {
      name: 'Network',
      cell: (row: ProfileWalletsTableDataProps) => {
        return (
          <div className={`profile-network-icons-${theme}`}>
            {Object.values(row.network).map((value: string) => {
              return <img key={value} title={networks[value].name} src={networks[value].icon} />;
            })}
          </div>
        );
      },
    },
    /*
    {
      name: 'Visibility',
      selector: (row: ProfileWalletsTableDataProps) => row.hidden,
      sortable: false,
      cell: (row: ProfileWalletsTableDataProps) => {
        return <>{row.hidden ? 'Hidden' : 'Shown'}</>;
      },
    },*/
    {
      name: '',
      selector: (row: ProfileWalletsTableDataProps) => row.button,
      cell: (row: ProfileWalletsTableDataProps) => {
        return (
          <div className={`table-actions-${theme}`}>
            {/*<Button
              onClick={() => setShowAddNewWallet(!showAddNewWallet)}
              color="three"
              label="Update"
            />*/}
            <img
              onClick={() => {
                setShowUpdateWallet(!showUpdateWallet);
                setUpdateAddress(row.address);
                setUpdateId(row.id.toString());
                setUpdateName(row.name);
                setUpdateNetwork(row.network);
              }}
              src={`/icons/edit-2-${theme}.svg`}
              alt=""
            />
            <img
              onClick={() =>
                confirmAlert({
                  closeOnClickOutside: false,
                  customUI: ({ onClose }) => {
                    return (
                      <ConfirmAlert title="Are you sure?" onClose={onClose}>
                        <div className="confirm-button-flex">
                          <BigButton type="light" size="small" onClick={onClose} name="No" />
                          <BigButton
                            type="dark"
                            size="small"
                            onClick={() => {
                              removeFromProfileWallets(row.id);
                              onClose();
                            }}
                            name="Yes, Delete it!"
                          />
                        </div>
                      </ConfirmAlert>
                    );
                  },
                })
              }
              src={`/icons/trash-${theme}.svg`}
              alt=""
            />
          </div>
        );
      },
    },
  ];

  // functions

  const hideWallet = async (id: number, hidden: boolean): Promise<void> => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API}/wallets.php`,
        params: {
          type: 'Profile',
          process: 'hide',
          id: id,
          hidden: hidden ? 0 : 1,
        },
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      if (response && response.data && response.data.code === 0) {
        setRedirect(true);
        // fetchWalletData();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // wallets
  const removeFromProfileWallets = async (id: number): Promise<void> => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API}/wallets.php`,
        params: {
          process: 'delete',
          id: id,
        },
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      if (response && response.data && response.data.code === 0) {
        setRedirect(true);
        // fetchWalletData();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const addToProfileWallets = async (): Promise<void> => {
    if (!validNewWallet || !newAddress || !newName || !newNetwork) {
      alert('you should enter a valid address and name');
    } else {
      try {
        const response = await axios({
          url: `${process.env.REACT_APP_API}/wallets.php`,
          params: {
            process: 'add',
            type: 'Profile',
            address: newAddress,
            name: newName,
            network: newNetwork,
          },
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        });

        if (response && response.data && response.data.code === 0) {
          setRedirect(true);
          /*
          setShowAddNewWallet(false);
          setNewName('');
          setNewNetwork([]);
          setValidNewWallet(false);
          setShowAddNewWalletError('');
          fetchWalletData();
          */
        } else if (response && response.data && response.data.data) {
          setShowAddNewWalletError(response.data.data);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const updateProfileWallet = async (): Promise<void> => {
    if (!updateName || !updateNetwork) {
      alert('you should enter a valid address and name');
    } else {
      try {
        const response = await axios({
          url: `${process.env.REACT_APP_API}/wallets.php`,
          params: {
            process: 'update',
            id: updateId,
            type: 'Profile',
            address: updateAddress,
            name: updateName,
            network: updateNetwork,
          },
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        });

        if (response && response.data && response.data.code === 0) {
          setRedirect(true);
          /*
          setShowUpdateWallet(false);
          setUpdateName('');
          setUpdateNetwork([]);
          setShowUpdateWalletError('');
          fetchWalletData();
          */
        } else if (response && response.data && response.data.data) {
          setShowUpdateWalletError(response.data.data);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const fetchWalletData = async (): Promise<void> => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API}/wallets.php`,
        params: {
          process: 'list',
          type: 'Profile',
        },
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });
      setLoading(false);
      if (response && response.data && response.data.data) setRawData(response.data.data);
      else setRawData([]);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const checkWalletAvailableNetworks = async (address: string): Promise<string[]> => {
    setLoading(true);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API}/check-networks.php`,
        params: {
          address: address,
        },
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });
      setLoading(false);
      if (response && response.data) return response.data.data;
      else return [];
    } catch (error) {
      setLoading(false);
      console.error(error);
      return [];
    }
  };

  const renderShowTable = (data: any): void => {
    setShowTable(<DataTable columns={walletsColumns} data={data} />);
  };

  const handleOnChangeAddNewWallet = async (e: any) => {
    setNewAddress(e.target.value);

    if (e.target.value) {
      if (ethers.utils.isAddress(e.target.value)) {
        const availableNetworks = await checkWalletAvailableNetworks(e.target.value);
        setNewNetwork(availableNetworks);

        const items: any = document.getElementById('new-network-selectors');
        for (let i = 0; i < items.children.length; i++) {
          items.children[i].classList.remove('active');
          if (availableNetworks.includes(items.children[i].title)) {
            items.children[i].classList.add('active');
          }
        }
        setValidNewWallet(true);
      } else {
        setValidNewWallet(false);
      }
    } else {
      setValidNewWallet(false);
    }
  };

  const handleOnChangeAddNewName = (e: any) => {
    setNewName(e.target.value);
  };

  const handleOnChangeUpdateName = (e: any) => {
    setUpdateName(e.target.value);
  };

  const handleOnChangeAddNetwork = (e: any) => {
    const items: any = e.currentTarget.parentNode;
    e.target.classList.toggle('active');
    const tmp: string[] = [];

    for (let i = 0; i < items.children.length; i++) {
      if (items.children[i].classList.contains('active')) tmp.push(items.children[i].title);
    }

    setNewNetwork(tmp);
  };

  const handleOnChangeUpdateNetwork = (e: any) => {
    const items: any = e.currentTarget.parentNode;
    e.target.classList.toggle('active');
    const tmp: string[] = [];

    for (let i = 0; i < items.children.length; i++) {
      if (items.children[i].classList.contains('active')) tmp.push(items.children[i].title);
    }

    setUpdateNetwork(tmp);
  };

  const updateWallet = () => {
    const onClose = () => {
      setShowUpdateWallet(false);
      setUpdateName('');
    };
    return (
      <>
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay">
            <div className="react-confirm-alert">
              <ConfirmAlert title="Update New Wallet" onClose={onClose}>
                <div className="search-input">{updateAddress}</div>
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Enter wallet name..."
                    onChange={e => handleOnChangeUpdateName(e)}
                    value={updateName}
                  />
                </div>
                <div className="network-selectors">
                  {networks &&
                    Object.keys(networks).map((key: string) => {
                      return (
                        <img
                          key={key}
                          title={key}
                          className={updateNetwork.includes(key) ? 'active' : ''}
                          onClick={e => handleOnChangeUpdateNetwork(e)}
                          src={networks[key].icon}
                        />
                      );
                    })}
                </div>
                {showUpdateWalletError && (
                  <div className="alert">
                    <img src="/icons/warning-solid.svg" />
                    {showUpdateWalletError}
                  </div>
                )}
                <div className="confirm-button-container">
                  <Button color="one" size="medium" label="Cancel" onClick={onClose} />
                  <Button
                    color="three"
                    size="medium"
                    disabled={!updateId || !updateAddress || !updateName || !updateNetwork}
                    onClick={() => {
                      updateProfileWallet();
                    }}
                    label="Update"
                  />
                </div>
              </ConfirmAlert>
            </div>
          </div>
        </div>
      </>
    );
  };

  const addNewWallet = () => {
    const onClose = () => {
      setShowAddNewWallet(false);
      setValidNewWallet(false);
      setNewName('');
    };

    return (
      <>
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay">
            <div className={`react-confirm-alert-${theme}`}>
              <ConfirmAlert title="Add New Wallet" onClose={onClose}>
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Enter wallet address..."
                    onChange={e => handleOnChangeAddNewWallet(e)}
                  />
                </div>
                <div className="search-input">
                  <input
                    maxLength={14}
                    type="text"
                    placeholder="Enter wallet name..."
                    onChange={e => handleOnChangeAddNewName(e)}
                  />
                </div>
                <div className="network-selectors" id="new-network-selectors">
                  {networks &&
                    Object.keys(networks).map((key: string) => {
                      return (
                        <img
                          key={key}
                          title={key}
                          id={key}
                          onClick={e => handleOnChangeAddNetwork(e)}
                          src={networks[key].icon}
                        />
                      );
                    })}
                </div>
                {showAddNewWalletError && (
                  <div className="alert">
                    <img src="/icons/warning-solid.svg" />
                    {showAddNewWalletError}
                  </div>
                )}
                <div className="confirm-button-container">
                  <Button color="one" size="medium" label="Cancel" onClick={onClose} />
                  <Button
                    color="three"
                    size="medium"
                    disabled={!validNewWallet || !newName || !newNetwork}
                    onClick={() => {
                      addToProfileWallets();
                    }}
                    label="Add to Profile"
                  />
                </div>
              </ConfirmAlert>
            </div>
          </div>
        </div>
      </>
    );
  };

  // use effect
  useEffect(() => {
    if (redirect) {
      setTimeout(() => {
        document.location.reload();
      }, 1000);
    }
  }, [redirect]);

  // use effect
  useEffect(() => {
    setShowAddNewWalletError('');
  }, [newName, newAddress]);

  // use effect
  useEffect(() => {
    setShowUpdateWalletError('');
  }, [updateName, updateAddress]);

  useEffect(() => {
    const initialTableData: ProfileWalletsTableDataProps[] = new Array();
    setTableData(initialTableData);

    if (config) {
      fetchWalletData();
    }
  }, [config]);

  useEffect(() => {
    renderShowTable(tableData);
    if (isMobile && document.getElementsByClassName('rdt_Table')[0]) {
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 50,
          behavior: 'smooth',
        });
      }, 200);
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 60,
          behavior: 'smooth',
        });
      }, 210);
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 70,
          behavior: 'smooth',
        });
      }, 220);

      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 0,
          behavior: 'smooth',
        });
      }, 800);
    }
  }, [tableData]);

  useEffect(() => {
    const tmpData: ProfileWalletsTableDataProps[] = new Array();

    Object.values(rawData).forEach((item: any) => {
      tmpData.push({
        id: Number(item.id),
        name: item.name,
        address: item.address,
        network: Object.keys(item.network),
        button: true,
        hidden: !!parseInt(item.hidden),
      });
    });

    setTableData(tmpData);
  }, [rawData]);

  const handleFiles = (files: any) => {
    const jsonBase64 = files.base64;
    const index = jsonBase64.indexOf(',');
    const encodedString = jsonBase64.substr(index + 1);

    const fileName = files.fileList[0].name;
    const formatString = /[^.]*$/.exec(fileName)[0];

    const isCSVFile = formatString.includes('csv');
    const isXLSFile = formatString.includes('xls');
    const isXLSXFile = formatString.includes('xlsx');

    if (isCSVFile || isXLSFile || isXLSXFile) {
      Papa.parse(files.fileList[0], {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          setCSVResult(results.data);
        },
      });
      console.log('file is valid');
      console.log(encodedString);
    } else {
      console.log('file is invalid');
    }
  };

  const uploadWallet = async (address: string): string => {
    let availableNetworkList: any[] = [];

    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API}/check-networks.php`,
        params: {
          address: address,
        },
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });
      if (response && response.data) availableNetworkList = response.data.data;
    } catch (error) {
      // error
    }

    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API}/wallets.php`,
        params: {
          process: 'add',
          type: 'Profile',
          address: address,
          name: address.substring(0, 8),
          network: availableNetworkList,
        },
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      if (response && response.data && response.data.code === 0) {
        return address;
      }
    } catch (error) {
      // error
    }
  };

  useEffect(() => {
    const fetchData = async (address: string) => {
      const r = await uploadWallet(address);
      setImportedWallets([...importedWallets, r]);
      setCurrentImportLine(currentImportLine + 1);
    };

    if (CSVResult && CSVResult.length > 0) {
      if (CSVResult[currentImportLine]) {
        setShowCSVLoadingScreen(true);
        fetchData(Object.values(CSVResult[currentImportLine])[0]);
      } else {
        setTimeout(() => {
          setShowCSVLoadingScreen(false);
          setRedirect(true);
        }, 500);
      }
    }
  }, [CSVResult, currentImportLine]);

  useEffect(() => {
    const tmp: any[] = [];
    if (CSVResult && CSVResult.length > 0) {
      console.log(importedWallets);
      CSVResult.forEach((item: any, index: number) => {
        tmp.push(
          <strong
            key={index}
            className={importedWallets.includes(Object.values(item)[0]) ? 'uploaded' : 'waiting'}
          >
            {Object.values(item)[0]}{' '}
            <img
              src={`/icons/${
                importedWallets.includes(Object.values(item)[0]) ? 'check' : 'question'
              }.svg`}
              alt=""
            />
          </strong>,
        );
      });
      setWalletRenderList(tmp.reduce((prev, curr) => [prev, curr]));
    }
  }, [importedWallets, CSVResult]);

  return (
    <div className="profile">
      <BigMenu horizontal={true} />
      {redirect && (
        <div className="redirect-info">Wallets are rearranged according to the changes...</div>
      )}
      {showCSVLoadingScreen && CSVResult && walletRenderList && (
        <>
          <div className="csv-loading-grayed-out" />
          <div className="csv-loading-info">
            CSV File loaded and wallets are importing...
            <br />
            {walletRenderList}
          </div>
        </>
      )}
      <div className={`profile-container ${redirect || showCSVLoadingScreen ? 'blurred' : ''}`}>
        {!isMobile && (
          <div className="csv-import">
            <Tooltip
              placement="bottom"
              className="tooltip"
              border="#ff6aff"
              background="var(--color-background-main)"
              color="var(--color-text-main)"
              content={
                'You can import file which includes wallet addresses with comma separated csv format.'
              }
            >
              <ReactFileReader
                handleFiles={handleFiles}
                fileTypes={['.xls', '.xlsx', '.csv']}
                base64={true}
              >
                <Button color="black" size="small" icon="csv" />
              </ReactFileReader>
            </Tooltip>
          </div>
        )}
        <div className="profile-container-content">
          {config && tableData && tableData.length > 0 && (
            <div className="mt-5">
              <div className={`table-border-top-${theme}`} />
              <div>{showTable}</div>
              <div className={`table-border-bottom-${theme}`} />
            </div>
          )}
          {!loading && (!tableData || tableData.length === 0) && (
            <div className="no-result mt-5">There is no wallet in your profile list.</div>
          )}
          <div className="mt-5">
            <div className="light-button-container">
              <div className="light-button">
                <Button
                  onClick={() => setShowAddNewWallet(!showAddNewWallet)}
                  color="one"
                  size="large"
                  label="Add New Wallet"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showAddNewWallet && addNewWallet()}
      {showUpdateWallet && updateWallet()}
    </div>
  );
};
